import LichThiDauByCountry from "@/components/LichThiDauByCountry";

/**
 * @param {object} props
 * @param {string} props.country
 */
export default function BangKeoKetQuaByCountry({ country }) {
  return <LichThiDauByCountry country={country} type="ketqua" />;
}
